import { render, staticRenderFns } from "./StudentWelfare.vue?vue&type=template&id=57be1b00"
import script from "./StudentWelfare.vue?vue&type=script&lang=js"
export * from "./StudentWelfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports